import { z } from 'zod'
import { SessionUserSchema, UserProfileSchema } from '@shared/lib/auth/session-types'

export const CurrentUserSchema = SessionUserSchema
export type CurrentUser = z.infer<typeof CurrentUserSchema>

export const UserProfileInputSchema = UserProfileSchema.extend({
  phone: z.string().optional(),
})

export type UserProfileInput = z.infer<typeof UserProfileInputSchema>
